<div class="main-frame-container" [attr.data-qa]="'main-frame-control1'">

  <div class="header-container" [attr.data-qa]="'main-frame-control2'" #headerContainer>

    <div class="title" [attr.data-qa]="'main-frame-control3'">
      <ng-content select="[title]"></ng-content>
      <ng-template [ngIf]="titleKey">{{titleKey | translate}}</ng-template>
    </div>

    <div class="commands" [hidden]="hideCommands" [attr.data-qa]="'main-frame-control4'">
      <ng-content select="[commands]"></ng-content>

      <div class="right-sidebar-container" [attr.data-qa]="'main-control12'" #rightSideBarContainer>
        <ng-content select="[right-sidebar-area]" [attr.data-qa]="'main-control13'"></ng-content>
      </div>
    </div>


  </div>


  <div class="body-container scrollable-content" [attr.data-qa]="'main-frame-control5'" #bodyContainer>
      <loader [show]="isLoading" [attr.data-qa]="'main-frame-control6'"></loader>
      <div class="body-content scrollable-content" [attr.data-qa]="'main-frame-control7'" #bodyContent>
        <ng-content select="[body]"></ng-content>
      </div>
  </div>
</div>
